import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'material-icons/iconfont/material-icons.css'

import i18n from '@/plugins/i18n'
import { getWhitelabelConfiguration } from '@/plugins/whitelabel/whitelabel.js'

const whitelabelConfiguration = getWhitelabelConfiguration(process.env.VUE_APP_WHITELABEL)

const vuetifyOptions = {
  theme: {
    dark: false,
    themes: whitelabelConfiguration.themes,
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
}

Vue.use(Vuetify)

export default new Vuetify(vuetifyOptions)
